// extracted by mini-css-extract-plugin
module.exports = {"liveAddressDetails":"index-module_liveAddressDetails_Zn8Ek"};